import { connect } from 'react-redux'
import { setLanguage } from 'src/modules/App/actions'

const mapDispatchToProps = {
  setLanguage,
}

export default connect(null, mapDispatchToProps)
